// import { RouteWithPermissions } from 'containers/route-with-permissions';
import React from 'react';
import { Switch } from 'react-router';
import { Index } from 'views/administration/extraDocument/list/Index';
import { RouteWithPermissions } from 'containers/route-with-permissions';
import { BUSINNESS_FUNCTIONS } from 'constants/roles';
import { FEATURE_TOGGLES } from '../../../constants/featureToggles';
import { Redirect } from 'react-router-dom';

export const ExtraDocumentRouting = () => {
    return (
        <Switch>
            <RouteWithPermissions
                path="/administration/extra-document/export"
                component={Index}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
                featuresToRestrict={[FEATURE_TOGGLES.EXTRA_DOCUMENT]}
            />
            <RouteWithPermissions
                path="/administration/extra-document/import"
                component={Index}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
                featuresToRestrict={[FEATURE_TOGGLES.EXTRA_DOCUMENT]}
            />
            <Redirect to="/administration/extra-document/export" />
        </Switch>
    );
};